<template>
    <div class="dashboard">
        <div class="container-fluid pt-3 pb-3 pl-3 pr-3" style="background-color:#ffffff;">
                <div class="container">
                    <div class="row">
                        <div class="col-6 pt-3">
                            <h2>B-e Box, La boîte à outils bien-être</h2>
                        </div>
                    </div>
                </div>
        </div>
        <div class="container mt-5">
            <div class="row">
                <div class="col-md-4 text-center mt-3">
                    <a href="/bebox/detail/">
                        <img :src="require('@/assets/group121.png')"/>
                    </a>
                    </div>
                <div class="col-md-4 text-center mt-3">
                    <a href="/bebox/detail/">
                        <img :src="require('@/assets/group122.png')"/>
                    </a>
                </div>
                <div class="col-md-4 text-center mt-3">
                    <a href="/bebox/detail/">
                    <img :src="require('@/assets/group123.png')"/>
                    </a>
                </div>
                <div class="col-md-4 text-center mt-3">
                    <a href="/bebox/detail/">
                    <img :src="require('@/assets/group124.png')"/>
                    </a>
                </div>
                <div class="col-md-4 text-center mt-3">
                    <a href="/bebox/detail/">
                    <img :src="require('@/assets/group125.png')"/>
                    </a>
                </div>
                <div class="col-md-4 text-center mt-3">
                    <a href="/bebox/detail/">
                    <img :src="require('@/assets/group126.png')"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import HomeItem from '../components/BeboxItem'
    import {mapState} from 'vuex';

    export default {
        name: 'dashboard',
        components: {HomeItem},
        computed: mapState({user: state => state.user.user}),
        data() {
        },
        layout(context) {
            return 'layout'
        },
        methods: {},
    };
</script>
